module.exports = __webpack_public_path__ + "static/img/illustration-register-v2-light.c213c0a2.png";